import {getDomainName} from '../../../utils/url'
import {cookieSecuritySettings} from '../../utils/cookies/cookieSecuritySettings'
import {isBrowser} from '../../utils/environment'

const maxAge = 365 * 2 // 2 years
const name = 'ip'

const config = {
  name,
  options: {
    maxAge,
    domain: !isBrowser ? '' : getDomainName(window.location.hostname),
    ...cookieSecuritySettings(true)
  }
}

export default config
